var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsPopupHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#E7ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1563 26.8334C34.8342 33.1042 37.5 35 37.5 35H16.5C16.5 35 20 32.5115 20 23.8C20 21.8202 20.7373 19.9209 22.0498 18.5209C23.3623 17.1209 25.145 16.3334 27 16.3334C27.3943 16.3334 27.7832 16.3684 28.1667 16.4384M29.0183 38.5C28.8132 38.8536 28.5188 39.1471 28.1646 39.3512C27.8104 39.5552 27.4088 39.6626 27 39.6626C26.5912 39.6626 26.1896 39.5552 25.8354 39.3512C25.4812 39.1471 25.1868 38.8536 24.9817 38.5M35.1667 23.3334C36.0949 23.3334 36.9852 22.9646 37.6415 22.3082C38.2979 21.6519 38.6667 20.7616 38.6667 19.8334C38.6667 18.9051 38.2979 18.0149 37.6415 17.3585C36.9852 16.7021 36.0949 16.3334 35.1667 16.3334C34.2384 16.3334 33.3482 16.7021 32.6918 17.3585C32.0354 18.0149 31.6667 18.9051 31.6667 19.8334C31.6667 20.7616 32.0354 21.6519 32.6918 22.3082C33.3482 22.9646 34.2384 23.3334 35.1667 23.3334Z",
    stroke: "#A3AED0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsPopupHead);
export default __webpack_public_path__ + "static/media/notifications-popup-head.714abee083894eb357ea5368722a6872.svg";
export { ForwardRef as ReactComponent };